import { StoreAction, XmAction } from 'store/actions';
import { EsimChange } from './models';

export function esimChangeReducer(state: EsimChange, action: XmAction<EsimChange>): EsimChange {
    switch (action.type) {
        case StoreAction.ESIM_CHANGE:
            return action.payload;
        default:
            return state;
    }
}
